import { EventEmitter } from '@angular/core';
var SlideButtonComponent = (function () {
    function SlideButtonComponent() {
        this.onBegin = new EventEmitter();
    }
    SlideButtonComponent.prototype.ngOnInit = function () {
    };
    SlideButtonComponent.prototype.ngAfterViewInit = function () {
        var circleBtn = document.getElementById('button_top'); //圆形按钮
        var bottomBtn = document.getElementById('button_bottom'); //圆形按钮下面的长条带
        var restartBtn = document.getElementById('restartBtn');
        var continueBtn = document.getElementById('continueBtn');
        var ifBool = false; //表示是否点击的状态；
        var button = document.getElementById('button');
        var remBase = document.documentElement.clientWidth / 7.5;
        var buttonWidth = 4.72 * remBase;
        var bottomBtnmax = 4.72 * remBase;
        var bottomBtnmin = 1.1 * remBase;
        var _this = this;
        if (this.set) {
            $("#button").css({
                "position": "absolute",
                "top": "0",
                "left": "50%",
                "marginLeft": "-2.36rem",
            });
        }
        circleBtn.addEventListener("touchstart", function (e) {
            e.stopPropagation();
            ifBool = true;
            bottomBtn.style.transition = "width 0s linear";
            _this.startPosition = e.touches[0].pageX || e.touches[0].clientX;
            _this.startbottomBtnWidth = bottomBtn.offsetWidth;
        });
        window.addEventListener("touchend", function (e) {
            ifBool = false;
            bottomBtn.style.transition = "width 0.5s";
            var nowbottomBtnWidth = bottomBtn.offsetWidth;
            var total = buttonWidth * 0.5; //button_bottom的百分之50
            if (nowbottomBtnWidth < total) {
                bottomBtn.style.width = bottomBtnmin + "px";
                _this.onBegin.emit(true);
            }
            if (nowbottomBtnWidth >= total) {
                bottomBtn.style.width = bottomBtnmax + "px";
                wenzi.style.opacity = "1";
                wenzi.style.transition = "opacity 1s";
            }
        });
        var wenzi = document.getElementById('wenzi');
        window.addEventListener("touchmove", function (e) {
            if (ifBool) {
                var x = e.touches[0].pageX || e.touches[0].clientX; //获取鼠标的x值
                var move = x - _this.startPosition; //移动后的坐标
                var bottomBtnWidth = _this.startbottomBtnWidth - move; //移动后的宽度
                var wenziminWidth = 2.1 * remBase; //字淡出的最小距离
                if (bottomBtnWidth < bottomBtnmin) {
                    bottomBtnWidth = bottomBtnmin;
                }
                if (bottomBtnWidth >= bottomBtnmax) {
                    bottomBtnWidth = bottomBtnmax;
                }
                if (move = wenziminWidth) {
                    wenzi.style.opacity = "0";
                    wenzi.style.transition = "opacity 1s";
                }
                bottomBtn.style.width = bottomBtnWidth + "px";
            }
        });
        bottomBtn.addEventListener("transitionend", function () {
            bottomBtn.style.transition = "width 0s linear";
        });
    };
    return SlideButtonComponent;
}());
export { SlideButtonComponent };



// WEBPACK FOOTER //
// ./src/app/slide-button/slide-button.component.ts.pre-build-optimizer.js